import React from 'react';
import { useNavigate } from 'react-router-dom';

const RSVPCancelled = () => {
  const navigate = useNavigate();

  return (
    <div className="login-container">
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '4rem', marginBottom: '20px' }}>❌</div>
        <h2 className="login-title">Payment Cancelled</h2>
        <p style={{ marginBottom: '20px', fontSize: '1.1rem' }}>
          Your payment was cancelled. No charges were made.
        </p>
        <div className="alert alert-info">
          <strong>No worries!</strong>
          <br />
          You can try again whenever you're ready.
        </div>
        <button
          className="submit-button"
          onClick={() => navigate('/')}
          style={{ marginTop: '20px' }}
        >
          Return to Events
        </button>
      </div>
    </div>
  );
};

export default RSVPCancelled;
